export default __webpack_public_path__ + "static/media/legal_information_new.d71dec11.png";